import { Button, Grid, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';

import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

import { DEBUG_ACTION_SIZE, DEBUG_DESCRIPTION_SIZE } from './DebugModal';

export const ResetPreferencesButton = () => {
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const handleClick = useCallback(() => {
    fddmSvc.resetPreferences();
  }, [fddmSvc]);

  return (
    <>
      <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
        <Typography>Reset preferences to defaults</Typography>
      </Grid>
      <Grid item xs={DEBUG_ACTION_SIZE}>
        <Button onClick={handleClick}>Click</Button>
      </Grid>
    </>
  );
};
